import React from 'react';
import {DroppableComponentProps} from '../models';
import {DragDropContextStore} from '../drag-drop-context/DragDropContextStore';
import {DragDropReactContext} from '../drag-drop-context/DragDropReactContext';
import {DroppableImpl} from './DroppableImpl';
import {DroppableReactContext} from './DroppableReactContext';
import {DroppableStore} from './DroppableStore';

export class Droppable extends React.Component<DroppableComponentProps> {
  render() {
    return (
      <DragDropReactContext.Consumer>
        {
          (contextStore: DragDropContextStore | null) =>
            (<DroppableReactContext.Consumer>
              {
                (droppableStore: DroppableStore | null) =>
                  this.childRenderer(contextStore, droppableStore)
              }
            </DroppableReactContext.Consumer>)
        }
      </DragDropReactContext.Consumer>);
  }

  childRenderer = (contextStore: DragDropContextStore | null, droppableStore: DroppableStore | null): React.ReactNode => {
    if (contextStore === null)
      return (
        <div className="alert alert-danger">
          <b>Droppable</b> must have <b>DragDropContext</b> as parent.
        </div>);
    const droppableId = this.props.droppableId;

    const {children, ...rest} = this.props;
    return (
      <DroppableImpl key={droppableId}
                     {...rest}
                     contextStore={contextStore}
                     parent={droppableStore}>
        {children}
      </DroppableImpl>);
  };


}
